import { TFunction } from 'react-i18next';

import { Address } from '../../../../../../types/address';
import { getAddressSchema } from '../../../../../validations/address';

export function toApiData(data: FormValues): Partial<FormValues> {
  let apiData: Partial<FormValues> = { ...data };

  return apiData;
}

export function getDefaultValues(data?: any) {
  const resolved = data?.resolvedAddress;
  const original = data?.address;

  return {
    municipalityId: resolved?.municipalityId ?? original?.municipalityId ?? null,
    municipalityName:
      resolved?.municipalityName ?? original?.municipalityName ?? '',
    placeId: resolved?.placeId ?? original?.placeId ?? null,
    placeName: resolved?.placeName ?? original?.placeName ?? '',
    streetId: resolved?.streetId ?? null,
    streetName: resolved?.streetName ?? '',
    housenumber: resolved?.housenumber ?? '',
    entrance: resolved?.entrance ?? '',
    apartment: resolved?.apartment ?? '',
    postcode: resolved?.postcode ?? '',
  };
}

export function getValidationSchema(t: TFunction) {
  return getAddressSchema(t, {});
}

export type FormValues = Address;
